import React, { useState } from 'react'
import Arrow from '../images/icon-arrow.svg';
import LeftAngle from '../images/icon-angle-left.svg';
import RightAngle from '../images/icon-angle-right.svg';
import ChairTable from '../images/desktop-image-hero-1.jpg'; 
import SecondPic from '../images/desktop-image-hero-2.jpg';
import ThirdPic from '../images/desktop-image-hero-3.jpg';
import Logo from '../images/logo.svg'
import Menu from '../images/icon-hamburger.svg';
import Close from '../images/icon-close.svg'

function UpperPart() {
    const [current, setCurrent] = useState(1);
    const [burger, setburger] = useState(false)

    const changeTextPlus = () => {
        if (current === 3){
            setCurrent(0)
        }
        if (current === 1 || 2){
            setCurrent(prev => prev + 1);
        }
    }

    const changeTextMinus = () => {
        if (current === 1) {
            setCurrent(4)
        }
        if (current === 2 || 3){
            setCurrent(prev => prev - 1);
        }
    }

    const handleBurger = () => {
        setburger(!burger);
    }

  return (
    <div className='w-full flex flex-col md:flex-row md:h-3/5 h-full'>
        <div className='md:w-7/12 relative h-96 md:h-full'>
            <div className='flex gap-8 text-white m-10 items-center justify-center sm:justify-start relative'>
                <img src={burger ? Close : Menu} alt="Menu bar" className='absolute -left-7 cursor-pointer z-50 sm:hidden' onClick={handleBurger}/>
                <img src={Logo} alt="Logo" />
                <nav className={`bg-white sm:bg-transparent w-full h-24 sm:h-full sm:relative fixed top-0 transition duration-300 text-black sm:text-white ${burger ? 'flex' : 'hidden'} justify-center items-center sm:block`}>
                    <ul className='flex gap-4 sm:gap-8'>
                        <li>
                            home
                            <div className='line'></div>
                        </li>
                        <li>
                            shop
                            <div className='line'></div>
                        </li>
                        <li>
                            about
                            <div className='line'></div>
                        </li>
                        <li>
                            contact
                            <div className='line'></div>
                        </li>
                    </ul>
                </nav>
            </div>
            <img src={
                current === 1 ? ChairTable :
                current === 2 ? SecondPic :
                current === 3 ? ThirdPic :
                ChairTable
            } alt="Chair and Table" className='absolute inset-0 -z-10 w-full h-full'/>
            <div className='bg-black flex w-32 h-16 justify-evenly items-center absolute right-0 bottom-0 md:hidden '>
                <div className='w-1/2 h-full flex items-center justify-center cursor-pointer hover:bg-zinc-600 transition ease-in-out duration-300' onClick={changeTextMinus}>
                    <img src={LeftAngle} alt="Left Angle Icon" className='w-4 h-6' />
                </div>
                <div className='w-1/2 h-full flex items-center justify-center cursor-pointer hover:bg-zinc-600 transition ease-in-out duration-300' onClick={changeTextPlus}>
                    <img src={RightAngle} alt="Right Angle Icon" className='w-4 h-6'/>
                </div>
            </div>
        </div>
        <div className='md:w-5/12 flex flex-col justify-center items-start lg:pl-24 pl-8 relative md:py-0 py-8'>
            <h1 className='md:text-3xl text-xl font-bold xl:w-7/12'>{ current === 1 ? 'Discover innovative ways to decorate' :
            current === 2 ? 'We are available all across the globe' : current === 3 ? 'Manufactured with the best materials' : 'Discover innovative ways to decorate'}</h1>
            <p className='mt-4 pr-1 w-5/6  text-sm text-gray-500'>{ current === 1 ? "We provide unmatched quality, comfort, and style for property owners across the country. Our experts combine form and function in bringing your vision to life. Create a room in your own style with our collection and make your property a reflection of you and what you love." :
            current === 2 ? "With stores all over the world, it's easy for you to find furniture for your home or place of business. Locally, we're in most major cities throughout the country. Find the branch nearest you using our store locator. Any questions? Don't hesitate to contact us today." : current === 3 ? " Our modern furniture store provide a high level of quality. Our company has invested in advanced technology to ensure that every product is made as perfect and as consistent as possible. With three decades of experience in this industry, we understand what customers want for their home and office.": "We provide unmatched quality, comfort, and style for property owners across the country. Our experts combine form and function in bringing your vision to life. Create a room in your own style with our collection and make your property a reflection of you and what you love."}</p>
            <div className='mt-4 flex items-center gap-2 cursor-pointer'>
                <h3 className='text-lg tracking-wide sm:tracking-widest hover:text-gray-500 transition-colors ease-in-out duration-500'>SHOP NOW</h3>
                <img src={Arrow} alt="Arrow" />
            </div>
            <div className='bg-black w-32 h-16 justify-evenly items-center absolute md:bottom-0 md:left-0 hidden md:flex'>
                <div className='w-1/2 h-full flex items-center justify-center cursor-pointer hover:bg-zinc-600 transition ease-in-out duration-300' onClick={changeTextMinus}>
                    <img src={LeftAngle} alt="Left Angle Icon" className='w-4 h-6' />
                </div>
                <div className='w-1/2 h-full flex items-center justify-center cursor-pointer hover:bg-zinc-600 transition ease-in-out duration-300' onClick={changeTextPlus}>
                    <img src={RightAngle} alt="Right Angle Icon" className='w-4 h-6'/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default UpperPart